.FieldError {
  overflow: auto;

  li {
    color: var(--accent-2);
    display: block;
    font-size: 0.75rem;
    line-height: 1.2;
    overflow-wrap: break-word;
    margin: 0;
    padding: 0;
  }
}

.FormError > li {
  font-size: 0.875rem;
}
